import React from 'react';
import { UserMessageProps } from '@copilotkit/react-ui';
import '@copilotkit/react-ui/styles.css';
import { AssistantTyping } from '@features/sidebar/components/assistant-message/AssistantTyping';
import { Markdown } from '@copilotkit/react-ui';
import { useCopilotChat } from '@copilotkit/react-core';
import { Role } from '@copilotkit/runtime-client-gql';
import { useAI } from 'src/hooks/useAI';

export const UserMessage = (props: UserMessageProps) => {
  const { message } = props;
  const { chatLoading } = useAI();
  const { visibleMessages } = useCopilotChat();

  // Extract content from message object or use message directly if it's a string
  const messageContent = typeof message === 'string' ? message : message?.content || '';

  const lastUserMessage = visibleMessages
    .filter((msg) => msg.isTextMessage() && msg.role === Role.User)
    .pop() as { content: string } | undefined;
  const isLastUser = lastUserMessage?.content === messageContent && chatLoading;

  return (
    <>
      <div className="flex justify-end items-center">
        <div className="user-message copilotKitMarkdownElementRight max-xl:py-2 max-xl:px-3 max-xl:mr-3 max-xl:my-3 max-xl:rounded-[8px]">
          {messageContent && <Markdown content={messageContent} />}
        </div>
      </div>
      <AssistantTyping isLoading={chatLoading && isLastUser} />
    </>
  );
};
